// Lightweight analytics helper. Fires to Google Analytics 4 / Google Ads (gtag)
// when present, and to PostHog (already loaded in index.html). Never throws so
// it can't break UX.
export const trackEvent = (event, params = {}) => {
  if (typeof window === 'undefined') return;
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    }
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(event, params);
    }
  } catch (e) {
    // analytics must never break the UI
  }
};
